import { useContext, useRef } from "react";
import * as constants from "@/config/constants";
import { getIsNotUserFiltered } from "@/selectors";
import { useSelector } from "react-redux";
import { Transition } from "react-transition-group";

import { CheckIcon } from "../../../../client/assets/icons/common/CheckIcon";
import { RightArrowIcon } from "../../../../client/assets/icons/common/RightArrowIcon";
import { BaseBenefitsList } from "../../../../components/BaseComponents/BaseBenefitsList";
import BaseCompanyBadge from "../../../../components/BaseComponents/BaseCompanyBadge";
import { BaseCompanyLogo } from "../../../../components/BaseComponents/BaseCompanyLogo";
import BaseCompanyName from "../../../../components/BaseComponents/BaseCompanyName";
import { BaseFeaturedCompanyHeader } from "../../../../components/BaseComponents/BaseFeaturedCompanyHeader";
import BaseGridRatingHorizontal from "../../../../components/BaseComponents/BaseGridRatingHorizontal";
import BaseLinkWrapper from "../../../../components/BaseComponents/BaseLinkWrapper";
import BaseServiceFlag from "../../../../components/BaseComponents/BaseServiceFlag";
import { BaseVisitLink } from "../../../../components/BaseComponents/BaseVisitLink";
import { CompanyContext } from "../../../../components/CompanyList/CompanyContext";
import { PhoneLink } from "./PhoneLink";
import { getStyles } from "./styles";

export const DemoGridTCR = () => {
	const { isFeaturedCompany } = useContext(CompanyContext);
	const { isNotUserFiltered } = useSelector(getIsNotUserFiltered);
	const styles = getStyles(isFeaturedCompany);
	const nodeRef = useRef(null);

	return (
		<Transition
			nodeRef={nodeRef}
			in
			appear={!isNotUserFiltered}
			timeout={constants.FILTERING_TRANSITION_DURATION}
			unmountOnExit
		>
			<div
				className={`tw:m-auto tw:mb-4 tw:max-w-[550px] tw:bg-white tw:shadow-[0px_3px_3px_0px_rgba(211,211,211,0.5)] tw:first:mt-4 tw:hover:shadow-[0px_3px_3px_0px_rgba(211,211,211,1.0)] tw:lg:mb-6 tw:lg:max-w-none ${
					isFeaturedCompany &&
					"tw:mt-6 tw:mb-8 tw:rounded-[3px] tw:border tw:border-solid tw:border-[#1d8ce0] tw:lg:mb-16 tw:lg:border-2"
				}`}
			>
				<BaseLinkWrapper>
					<BaseFeaturedCompanyHeader {...styles.featuredCompanyHeader} />
				</BaseLinkWrapper>
				<div className="tw:relative">
					<BaseLinkWrapper>
						<BaseServiceFlag classNames={styles.serviceFlag} />
					</BaseLinkWrapper>

					<div className="tw:flex tw:flex-col tw:flex-wrap tw:gap-4 tw:p-4 tw:lg:flex-row tw:lg:gap-0 tw:lg:p-4">
						<div className="tw:flex tw:w-full tw:justify-center tw:lg:max-w-[18%] tw:lg:shrink-0 tw:lg:grow-0 tw:lg:basis-[21.28%] tw:lg:pr-[30px] tw:lg:pl-9">
							<div className="tw:flex tw:w-40 tw:flex-col tw:justify-center tw:gap-2 tw:lg:gap-4">
								<BaseLinkWrapper>
									<BaseCompanyLogo classNames={styles.companyLogo} />
									<BaseGridRatingHorizontal classNames={styles.rating} />
								</BaseLinkWrapper>
							</div>
						</div>

						<div className="tw:flex tw:w-full tw:max-w-full tw:lg:max-w-[64%] tw:lg:shrink-0 tw:lg:grow-0 tw:lg:basis-[59.7%] tw:lg:pr-[22px] tw:lg:pl-[30px]">
							<BaseLinkWrapper>
								<div className="tw:flex tw:w-full tw:flex-col">
									<BaseCompanyName className="tw:mb-0 tw:text-xl tw:font-bold tw:tracking-[-0.2px] tw:text-[#000F10] tw:lg:text-2xl tw:lg:leading-8 tw:lg:tracking-[-0.48px]" />
									<BaseCompanyBadge
										classNames={styles.companyBadge}
										iconColor={"white"}
									/>
									<BaseBenefitsList
										{...styles.benefitsList}
										icon={
											<CheckIcon className="tw:mt-1 tw:mr-1 tw:text-[#1d8ce0]" />
										}
									/>
								</div>
							</BaseLinkWrapper>
						</div>

						<div className="tw:flex tw:w-full tw:max-w-full tw:lg:max-w-[19%] tw:lg:shrink-0 tw:lg:grow-0 tw:lg:basis-[19.09%] tw:lg:pl-0 tw:lg2:pl-[22px]">
							<div className="tw:flex tw:w-full tw:flex-col tw:items-center tw:justify-around tw:sm:flex-row tw:lg:flex-col tw:lg:justify-center">
								<PhoneLink className={"tw:w-[175px] tw:lg:w-full"} />
								<BaseLinkWrapper className={"tw:w-fit tw:lg:w-full"}>
									<BaseVisitLink
										{...styles.visitLink}
										icon={<RightArrowIcon />}
									>
										Visit Site
									</BaseVisitLink>
								</BaseLinkWrapper>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Transition>
	);
};
